import axios from 'axios';

export default {
  namespaced: true,
  state: {
    userLoggedIn: null,
  },
  getters: {
    isLoggedIn(state) {
      return !!state.userLoggedIn;
    },
    userLoggedInFullName(state) {
      if (!state.userLoggedIn) return '';
      return `${state.userLoggedIn.firstName} ${state.userLoggedIn.lastName}`;
    },
    userLoggedInImage(state) {
      if (!state.userLoggedIn) return 'https://api.adorable.io/avatars/58/.png';
      return state.userLoggedIn.profileImages ? state.userLoggedIn.profileImages.sizeX58 : '';
    },
  },
  mutations: {
    setUserLoggedIn(state, user) {
      state.userLoggedIn = user;
    },
  },
  actions: {
    async retrieveProfile({ commit }) {
      try {
        const user = await axios.get('/auth/me', { withCredentials: true });
        commit('setUserLoggedIn', user.data);
        return user;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
  },
};
